import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      !_vm.isModal
        ? [
            _c("div", { staticClass: "display-1" }, [
              _vm._v("Novedades Help Center"),
            ]),
            _c(VBreadcrumbs, {
              staticClass: "pa-0 py-2",
              attrs: { items: _vm.breadcrumbs },
            }),
            _c(
              VCard,
              { staticClass: "mt-2 pb-3 pr-3" },
              [
                _c(
                  VTabs,
                  {
                    attrs: { vertical: "" },
                    model: {
                      value: _vm.tab,
                      callback: function ($$v) {
                        _vm.tab = $$v
                      },
                      expression: "tab",
                    },
                  },
                  [
                    _c(
                      VTab,
                      {
                        on: {
                          click: function ($event) {
                            return _vm.sendtoGA(0)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("menu.data_platform")))]
                    ),
                    _c(
                      VTabItem,
                      [
                        _c(
                          VCarousel,
                          {
                            attrs: {
                              height: "auto",
                              "hide-delimiter-background": "",
                              "show-arrows-on-hover": "",
                            },
                          },
                          _vm._l(_vm.news, function (item, i) {
                            return item.module == "data_platform"
                              ? _c(
                                  VCarouselItem,
                                  { key: i },
                                  [
                                    _c(
                                      VCard,
                                      {
                                        staticClass: "mx-10",
                                        attrs: { outlined: "" },
                                      },
                                      [
                                        _c(
                                          VCardTitle,
                                          { staticClass: "justify-center" },
                                          [
                                            _c("h2", [
                                              _vm._v(_vm._s(item.title)),
                                            ]),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex text-center justify-center",
                                          },
                                          [
                                            _c(VImg, {
                                              attrs: {
                                                src: item.image,
                                                "max-height": "600",
                                                "max-width": "500",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          VCardText,
                                          { staticClass: "mb-4 text-center" },
                                          [
                                            _c("h5", [
                                              _vm._v(_vm._s(item.description)),
                                            ]),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e()
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      VTab,
                      {
                        on: {
                          click: function ($event) {
                            return _vm.sendtoGA(1)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("menu.audience")))]
                    ),
                    _c(
                      VTabItem,
                      [
                        _c(
                          VCarousel,
                          {
                            attrs: {
                              height: "auto",
                              "hide-delimiter-background": "",
                              "show-arrows-on-hover": "",
                            },
                          },
                          _vm._l(_vm.news, function (item, i) {
                            return item.module == "audience"
                              ? _c(
                                  VCarouselItem,
                                  { key: i },
                                  [
                                    _c(
                                      VCard,
                                      {
                                        staticClass: "mx-10",
                                        attrs: { outlined: "" },
                                      },
                                      [
                                        _c(
                                          VCardTitle,
                                          { staticClass: "justify-center" },
                                          [
                                            _c("h2", [
                                              _vm._v(_vm._s(item.title)),
                                            ]),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex text-center justify-center",
                                          },
                                          [
                                            _c(VImg, {
                                              attrs: {
                                                src: item.image,
                                                "max-height": "600",
                                                "max-width": "500",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          VCardText,
                                          { staticClass: "mb-4 text-center" },
                                          [
                                            _c("h5", [
                                              _vm._v(_vm._s(item.description)),
                                            ]),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e()
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      VTab,
                      {
                        on: {
                          click: function ($event) {
                            return _vm.sendtoGA(2)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("menu.attributes")))]
                    ),
                    _c(
                      VTabItem,
                      [
                        _c(
                          VCarousel,
                          {
                            attrs: {
                              height: "auto",
                              "hide-delimiter-background": "",
                              "show-arrows-on-hover": "",
                            },
                          },
                          _vm._l(_vm.news, function (item, i) {
                            return item.module == "attributes"
                              ? _c(
                                  VCarouselItem,
                                  { key: i },
                                  [
                                    _c(
                                      VCard,
                                      {
                                        staticClass: "mx-10",
                                        attrs: { outlined: "" },
                                      },
                                      [
                                        _c(
                                          VCardTitle,
                                          { staticClass: "justify-center" },
                                          [
                                            _c("h2", [
                                              _vm._v(_vm._s(item.title)),
                                            ]),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex text-center justify-center",
                                          },
                                          [
                                            _c(VImg, {
                                              attrs: {
                                                src: item.image,
                                                "max-height": "600",
                                                "max-width": "500",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          VCardText,
                                          { staticClass: "mb-4 text-center" },
                                          [
                                            _c("h5", [
                                              _vm._v(_vm._s(item.description)),
                                            ]),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e()
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      VTab,
                      {
                        on: {
                          click: function ($event) {
                            return _vm.sendtoGA(3)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("menu.customer_insights")))]
                    ),
                    _c(
                      VTabItem,
                      [
                        _c(
                          VCarousel,
                          {
                            attrs: {
                              height: "auto",
                              "hide-delimiter-background": "",
                              "show-arrows-on-hover": "",
                            },
                          },
                          _vm._l(_vm.news, function (item, i) {
                            return item.module == "customer_insights"
                              ? _c(
                                  VCarouselItem,
                                  { key: i },
                                  [
                                    _c(
                                      VCard,
                                      {
                                        staticClass: "mx-10",
                                        attrs: { outlined: "" },
                                      },
                                      [
                                        _c(
                                          VCardTitle,
                                          { staticClass: "justify-center" },
                                          [
                                            _c("h2", [
                                              _vm._v(_vm._s(item.title)),
                                            ]),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex text-center justify-center",
                                          },
                                          [
                                            _c(VImg, {
                                              attrs: {
                                                src: item.image,
                                                "max-height": "600",
                                                "max-width": "500",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          VCardText,
                                          { staticClass: "mb-4 text-center" },
                                          [
                                            _c("h5", [
                                              _vm._v(
                                                _vm._s(item.description) + " "
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e()
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      VTab,
                      {
                        on: {
                          click: function ($event) {
                            return _vm.sendtoGA(4)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("menu.analytic_services")))]
                    ),
                    _c(
                      VTabItem,
                      [
                        _c(
                          VCarousel,
                          {
                            attrs: {
                              height: "auto",
                              "hide-delimiter-background": "",
                              "show-arrows-on-hover": "",
                            },
                          },
                          _vm._l(_vm.news, function (item, i) {
                            return item.module == "analytic_services"
                              ? _c(
                                  VCarouselItem,
                                  { key: i },
                                  [
                                    _c(
                                      VCard,
                                      {
                                        staticClass: "mx-10",
                                        attrs: { outlined: "" },
                                      },
                                      [
                                        _c(
                                          VCardTitle,
                                          { staticClass: "justify-center" },
                                          [
                                            _c("h2", [
                                              _vm._v(_vm._s(item.title)),
                                            ]),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex text-center justify-center",
                                          },
                                          [
                                            _c(VImg, {
                                              attrs: {
                                                src: item.image,
                                                "max-height": "600",
                                                "max-width": "500",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          VCardText,
                                          { staticClass: "mb-4 text-center" },
                                          [
                                            _c("h5", [
                                              _vm._v(_vm._s(item.description)),
                                            ]),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e()
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        : [
            _c(
              VTabs,
              {
                attrs: { vertical: "" },
                model: {
                  value: _vm.tab,
                  callback: function ($$v) {
                    _vm.tab = $$v
                  },
                  expression: "tab",
                },
              },
              [
                _c(
                  VTab,
                  {
                    on: {
                      click: function ($event) {
                        return _vm.sendtoGA(0)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("menu.data_platform")))]
                ),
                _c(
                  VTabItem,
                  [
                    _c(
                      VCarousel,
                      {
                        attrs: {
                          height: "auto",
                          "hide-delimiter-background": "",
                          "show-arrows-on-hover": "",
                        },
                      },
                      _vm._l(_vm.news, function (item, i) {
                        return item.module == "data_platform"
                          ? _c(
                              VCarouselItem,
                              { key: i },
                              [
                                _c(
                                  VCard,
                                  {
                                    staticClass: "mx-10",
                                    attrs: { outlined: "" },
                                  },
                                  [
                                    _c(
                                      VCardTitle,
                                      { staticClass: "justify-center" },
                                      [_c("h2", [_vm._v(_vm._s(item.title))])]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex text-center justify-center",
                                      },
                                      [
                                        _c(VImg, {
                                          attrs: {
                                            src: item.image,
                                            "max-height": "600",
                                            "max-width": "500",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      VCardText,
                                      { staticClass: "mb-4 text-center" },
                                      [
                                        _c("h5", [
                                          _vm._v(_vm._s(item.description)),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e()
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  VTab,
                  {
                    on: {
                      click: function ($event) {
                        return _vm.sendtoGA(1)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("menu.audience")))]
                ),
                _c(
                  VTabItem,
                  [
                    _c(
                      VCarousel,
                      {
                        attrs: {
                          height: "auto",
                          "hide-delimiter-background": "",
                          "show-arrows-on-hover": "",
                        },
                      },
                      _vm._l(_vm.news, function (item, i) {
                        return item.module == "audience"
                          ? _c(
                              VCarouselItem,
                              { key: i },
                              [
                                _c(
                                  VCard,
                                  {
                                    staticClass: "mx-10",
                                    attrs: { outlined: "" },
                                  },
                                  [
                                    _c(
                                      VCardTitle,
                                      { staticClass: "justify-center" },
                                      [_c("h2", [_vm._v(_vm._s(item.title))])]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex text-center justify-center",
                                      },
                                      [
                                        _c(VImg, {
                                          attrs: {
                                            src: item.image,
                                            "max-height": "600",
                                            "max-width": "500",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      VCardText,
                                      { staticClass: "mb-4 text-center" },
                                      [
                                        _c("h5", [
                                          _vm._v(_vm._s(item.description)),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e()
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  VTab,
                  {
                    on: {
                      click: function ($event) {
                        return _vm.sendtoGA(2)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("menu.attributes")))]
                ),
                _c(
                  VTabItem,
                  [
                    _c(
                      VCarousel,
                      {
                        attrs: {
                          height: "auto",
                          "hide-delimiter-background": "",
                          "show-arrows-on-hover": "",
                        },
                      },
                      _vm._l(_vm.news, function (item, i) {
                        return item.module == "attributes"
                          ? _c(
                              VCarouselItem,
                              { key: i },
                              [
                                _c(
                                  VCard,
                                  {
                                    staticClass: "mx-10",
                                    attrs: { outlined: "" },
                                  },
                                  [
                                    _c(
                                      VCardTitle,
                                      { staticClass: "justify-center" },
                                      [_c("h2", [_vm._v(_vm._s(item.title))])]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex text-center justify-center",
                                      },
                                      [
                                        _c(VImg, {
                                          attrs: {
                                            src: item.image,
                                            "max-height": "600",
                                            "max-width": "500",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      VCardText,
                                      { staticClass: "mb-4 text-center" },
                                      [
                                        _c("h5", [
                                          _vm._v(_vm._s(item.description)),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e()
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  VTab,
                  {
                    on: {
                      click: function ($event) {
                        return _vm.sendtoGA(3)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("menu.customer_insights")))]
                ),
                _c(
                  VTabItem,
                  [
                    _c(
                      VCarousel,
                      {
                        attrs: {
                          height: "auto",
                          "hide-delimiter-background": "",
                          "show-arrows-on-hover": "",
                        },
                      },
                      _vm._l(_vm.news, function (item, i) {
                        return item.module == "customer_insights"
                          ? _c(
                              VCarouselItem,
                              { key: i },
                              [
                                _c(
                                  VCard,
                                  {
                                    staticClass: "mx-10",
                                    attrs: { outlined: "" },
                                  },
                                  [
                                    _c(
                                      VCardTitle,
                                      { staticClass: "justify-center" },
                                      [_c("h2", [_vm._v(_vm._s(item.title))])]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex text-center justify-center",
                                      },
                                      [
                                        _c(VImg, {
                                          attrs: {
                                            src: item.image,
                                            "max-height": "600",
                                            "max-width": "500",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      VCardText,
                                      { staticClass: "mb-4 text-center" },
                                      [
                                        _c("h5", [
                                          _vm._v(
                                            _vm._s(item.description) + " "
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e()
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  VTab,
                  {
                    on: {
                      click: function ($event) {
                        return _vm.sendtoGA(4)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("menu.analytic_services")))]
                ),
                _c(
                  VTabItem,
                  [
                    _c(
                      VCarousel,
                      {
                        attrs: {
                          height: "auto",
                          "hide-delimiter-background": "",
                          "show-arrows-on-hover": "",
                        },
                      },
                      _vm._l(_vm.news, function (item, i) {
                        return item.module == "analytic_services"
                          ? _c(
                              VCarouselItem,
                              { key: i },
                              [
                                _c(
                                  VCard,
                                  {
                                    staticClass: "mx-10",
                                    attrs: { outlined: "" },
                                  },
                                  [
                                    _c(
                                      VCardTitle,
                                      { staticClass: "justify-center" },
                                      [_c("h2", [_vm._v(_vm._s(item.title))])]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex text-center justify-center",
                                      },
                                      [
                                        _c(VImg, {
                                          attrs: {
                                            src: item.image,
                                            "max-height": "600",
                                            "max-width": "500",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      VCardText,
                                      { staticClass: "mb-4 text-center" },
                                      [
                                        _c("h5", [
                                          _vm._v(_vm._s(item.description)),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e()
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }